import { render, staticRenderFns } from "./WhyLime24Tab.vue?vue&type=template&id=eef660fa&scoped=true"
import script from "./WhyLime24Tab.vue?vue&type=script&lang=js"
export * from "./WhyLime24Tab.vue?vue&type=script&lang=js"
import style0 from "./WhyLime24Tab.vue?vue&type=style&index=0&id=eef660fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef660fa",
  null
  
)

export default component.exports